module.exports = __webpack_public_path__ + "static/media/L.9b2e8301.jpg";